//import Parameters from './screens/index.vue';
const Parameters = () => import('./screens/index.vue')

import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import { checkUserPermissions } from '@/services/auth';

const parametersRoutes = [];

if (
  checkUserPermissions([
    PERMISSIONS_KEYS.PARAMETERS_VIEW,
    PERMISSIONS_KEYS.PARAMETERS_EDIT,
  ])
) {
  parametersRoutes.push({
    path: '/parametros',
    name: 'Administração|Parâmetros',
    component: Parameters,
    meta: {
      icon: 'fa-sliders-h',
      requiresAuth: true,
    },
  });
}

export { parametersRoutes };
